export default "__VITE_ASSET__0749d9da__"